export default {
  namespaced: true,
  state: {
    dict: {},
    // dict: {},
    // level: {},
    // area: {},
    // bankType: {},
    // msgKind: {},
    // msgAutFlag: {},
    // sysMachStatus: {},
    // finanIns: {},
  },
  mutations: {
    setDict(state, payload) {
      state.dict = payload;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js